import { render, staticRenderFns } from "./OptionMenuBox.vue?vue&type=template&id=6d621aa4"
import script from "./OptionMenuBox.vue?vue&type=script&lang=ts"
export * from "./OptionMenuBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports